import moment from 'moment';
import { CostReportItem } from '../../../features/cost-report/types';

export const matchesCostReportSearch = (item: CostReportItem, normalizedSearch: string): boolean => {
    const formattedDate = item.date ? moment(item.date) : null;
    const matchesFormattedDate = formattedDate?.isValid()
        ? [formattedDate.format('MM/DD/YYYY'), formattedDate.format('DD.MM.YYYY')]
            .some((formatted) => formatted.toLowerCase().includes(normalizedSearch))
        : false;

    return item.employeeName.toLowerCase().includes(normalizedSearch)
        || item.projectName?.toLowerCase().includes(normalizedSearch)
        || item.note?.toLowerCase().includes(normalizedSearch)
        || item.date?.toLowerCase().includes(normalizedSearch)
        || matchesFormattedDate
        || item.amount.toString().toLowerCase().includes(normalizedSearch);
};

export const filterCostReportItems = (
    items: CostReportItem[] = [],
    search?: string
): CostReportItem[] => {
    if (!items.length) {
        return items;
    }

    const normalizedSearch = search?.trim().toLowerCase() ?? '';
    if (!normalizedSearch) {
        return items;
    }

    return items.filter((item) => matchesCostReportSearch(item, normalizedSearch));
};
